import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import PolicyPage from "@/pages/PolicyPage";
import ContactPage from "@/pages/ContactPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          if (window.__lenis) {
            window.__lenis.scrollTo(el, { offset: -72 });
          } else {
            el.scrollIntoView();
          }
        }
      }, 80);
      return () => clearTimeout(timer);
    }
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PolicyPage slug="privacy" />} />
        <Route path="/terms" element={<PolicyPage slug="terms" />} />
        <Route path="/refund-policy" element={<PolicyPage slug="refund" />} />
        <Route path="/account-deletion" element={<PolicyPage slug="account-deletion" />} />
        <Route path="/ai-disclaimer" element={<PolicyPage slug="ai-disclaimer" />} />
        <Route path="/policies/:slug" element={<PolicyPage />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
